import PropTypes from "prop-types";

const ProgressBar = ({ width, percentage, showPercentage = true }) => {
  return (
    <div className="flex gap-2 items-center justify-center w-full">
      <div className="relative overflow-hidden rounded-md bg-primary-opacity h-2 flex-1 min-w-[40px]">
        <div
          className="absolute bg-primary rounded-md h-2 left-0"
          style={{ width: width }}
        ></div>
      </div>
      {showPercentage && <p className="w-8 text-xs">{percentage}%</p>}
    </div>
  );
};

ProgressBar.propTypes = {
  width: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  showPercentage: PropTypes.bool,
};

export default ProgressBar;
